import Statsig from 'statsig-node';

/*
    Statsig helper functions for experiment querying server-side
*/

export const initializeStatsig = async () => {
    const serverKey = process.env.STATSIG_SERVER_KEY || '';

    try {
        await Statsig.initialize(serverKey);
    } catch (error) {
        console.error('failed to initialize Statsig SDK', {
            error: JSON.stringify(error, Object.getOwnPropertyNames(error)),
        });
    }
};

/**
 * Determines whether the current viewer can access a feature gate if they
 * possess the necessary requisites defined as rules on the target feature gate in Statsig.
 *
 * TODO: Hydrate values for other Statsig feature gate rules per https://docs.statsig.com/client/concepts/user
 */
export const isFeatureGateEnabled = (
    featureGate: string,
    userId: string,
    locale?: string,
    custom?: Record<string, string | number | boolean | Array<string> | undefined>
): boolean => {
    try {
        return Statsig.checkGateSync(
            {
                userID: userId,
                locale,
                custom,
            },
            featureGate
        );
    } catch (error) {
        console.error(`DS Middleware: Error checking feature gate ${featureGate}: ${error}`);
        return false;
    }
};

export const getExperimentGroup = (
    userId: string | undefined,
    experimentKey: string
): string | null => {
    if (!userId) {
        console.error(
            `DS Middleware: User ID is undefined, returning null for experiment ${experimentKey} in getExperimentGroup`
        );
        return null;
    }

    const experiment = Statsig.getExperimentSync({ userID: userId }, experimentKey);

    if (!experiment) {
        console.error(`DS Middleware: Failed to get experiment ${experimentKey} from Statsig`);
        return null;
    }

    const experimentGroup = experiment.getGroupName();

    if (!experimentGroup) {
        console.error(
            `DS Middleware: Failed to get experiment group for experiment ${experimentKey} from Statsig`
        );
        return null;
    }

    return experimentGroup;
};

export const getExperimentVariationNoExposure = (
    experimentId: string,
    testUserId: string,
    culture: string
): string | null => {
    try {
        const experiment = Statsig.getExperimentWithExposureLoggingDisabledSync(
            { userID: testUserId, locale: culture, custom: { culture } },
            experimentId
        );
        return experiment.getGroupName();
    } catch (error) {
        console.error('Error getting Statsig experiment variation', error);
        return null;
    }
};
